import getQuestaoInternaFromApi from './getQuestaoInternaFromApi';

const pvNormalizarResposta = pResposta => {
  if (pResposta == null) {
    return {};
  }

  if (typeof pResposta === 'string') {
    const xRespostaTexto = pResposta.trim();

    if (!xRespostaTexto) {
      return {};
    }

    try {
      const xParseado = JSON.parse(xRespostaTexto);

      if (xParseado && typeof xParseado === 'object') {
        return xParseado;
      }

      return {
        valor: xParseado
      };
    } catch (_pErro) {
      return {
        valor: pResposta
      };
    }
  }

  if (typeof pResposta === 'object') {
    return pResposta;
  }

  return {
    valor: pResposta
  };
};

const pvTemValor = pValor => {
  return !(pValor === null || pValor === undefined || pValor === '');
};

const pvObterLabelRespostaDominio = (pRespostaDominio, pValor) => {
  if (!Array.isArray(pRespostaDominio) || pRespostaDominio.length === 0) {
    return null;
  }

  const xValorNumerico = Number(pValor);

  if (!Number.isFinite(xValorNumerico)) {
    return null;
  }

  const xDominioSelecionado = pRespostaDominio.find(pItem => {
    const xIdItem = Number(pItem?.id);
    const xValorItem = Number(pItem?.valor);

    return xIdItem === xValorNumerico || xValorItem === xValorNumerico;
  });

  if (xDominioSelecionado?.label) {
    return xDominioSelecionado.label;
  }

  const xDominioPorPosicao = pRespostaDominio[xValorNumerico - 1] || pRespostaDominio[xValorNumerico];

  return xDominioPorPosicao?.label || null;
};

const hydrateAvaliacaoRespostas = (pListByAvaliacaoData = []) => {
  const xRespostasPorQuestao = (Array.isArray(pListByAvaliacaoData) ? pListByAvaliacaoData : []).reduce(
    (pAcc, pItem) => {
      const xQuestaoId = Number(pItem?.avaliacao_questao_id);

      if (!Number.isFinite(xQuestaoId) || xQuestaoId <= 0) {
        return pAcc;
      }

      const xRespostaNormalizada = pvNormalizarResposta(pItem?.resposta);
      const xValor = xRespostaNormalizada?.valor;
      const xRespostaTipo = pItem?.resposta_tipo || null;
      const xRespostaDominio = Array.isArray(pItem?.resposta_dominio) ? pItem.resposta_dominio : [];
      const xInterna = getQuestaoInternaFromApi(pItem);
      const xRespostaLabel =
        xRespostaTipo === 'MUL' ? pvObterLabelRespostaDominio(xRespostaDominio, xValor) : null;
      const xRespondida = pvTemValor(xValor);

      pAcc[xQuestaoId] = {
        avaliacao_questao_id: xQuestaoId,
        resposta_tipo: xRespostaTipo,
        resposta: xRespostaNormalizada,
        valor: xValor,
        label: xRespostaLabel,
        resposta_dominio: xRespostaDominio,
        interna: xInterna,
        comentario: pItem?.comentario || '',
        nota: pItem?.nota ?? null,
        revisor_justificativa: pItem?.revisor_justificativa || '',
        revisor_nota: pItem?.revisor_nota ?? null,
        revisor_usuario_id: pItem?.revisor_usuario_id ?? null,
        respondida: xRespondida
      };

      return pAcc;
    },
    {}
  );

  const xRespondidas = Object.values(xRespostasPorQuestao).reduce((pCount, pResposta) => {
    return pResposta?.respondida ? pCount + 1 : pCount;
  }, 0);

  return {
    respostasPorQuestao: xRespostasPorQuestao,
    respondidas: xRespondidas
  };
};

export default hydrateAvaliacaoRespostas;
